import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCapeVerde = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_449)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C15.6371 24 18.896 22.3817 21.0966 19.8261H2.90338C5.10402 22.3817 8.36291 24 12 24Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 5.37262 18.6274 0 12 0C5.37262 0 0 5.37262 0 12C0 13.0831 0.144375 14.1323 0.413391 15.1305H23.5867C23.8556 14.1323 24 13.0831 24 12Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.953827 16.6957C1.18516 17.2392 1.45558 17.762 1.76134 18.2609H22.2388C22.5445 17.7619 22.8149 17.2392 23.0463 16.6957H0.953827Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.57767 12.7826L8.77192 13.3805H9.40056L8.89201 13.75L9.08626 14.3478L8.57767 13.9783L8.06907 14.3478L8.26337 13.75L7.75482 13.3805H8.38346L8.57767 12.7826Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.57767 20.6087L8.77192 21.2066H9.40056L8.89201 21.576L9.08626 22.1739L8.57767 21.8044L8.06907 22.1739L8.26337 21.576L7.75482 21.2066H8.38346L8.57767 20.6087Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.93472 17.962L5.12897 18.5598H5.75761L5.24907 18.9293L5.44331 19.5272L4.93472 19.1577L4.42613 19.5272L4.62047 18.9293L4.11188 18.5598H4.74047L4.93472 17.962Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.32622 13.5652L6.52047 14.1631H7.14906L6.64056 14.5326L6.83481 15.1305L6.32622 14.7609L5.81762 15.1305L6.01197 14.5326L5.50333 14.1631H6.13197L6.32622 13.5652Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.11188 16.0273L4.74038 16.0273L4.93467 15.4293L5.12897 16.0273L5.75761 16.0272L5.24902 16.3967L5.44331 16.9946L4.93467 16.6251L4.42613 16.9945L4.62038 16.3967L4.11188 16.0273Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.81766 21.2771L6.01191 20.6793L5.50327 20.3099H6.13191L6.3262 19.712L6.5205 20.3098H7.14909L6.6405 20.6793L6.83475 21.2772L6.32616 20.9077L5.81766 21.2771Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.2192 17.962L12.025 18.5598H11.3964L11.9049 18.9293L11.7106 19.5272L12.2192 19.1577L12.7278 19.5272L12.5335 18.9293L13.0421 18.5598H12.4135L12.2192 17.962Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8278 13.5652L10.6336 14.1631H10.0049L10.5134 14.5326L10.3192 15.1305L10.8278 14.7609L11.3364 15.1305L11.1421 14.5326L11.6506 14.1631H11.022L10.8278 13.5652Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.0421 16.0273L12.4136 16.0273L12.2193 15.4293L12.025 16.0273L11.3964 16.0272L11.9049 16.3967L11.7106 16.9946L12.2193 16.6251L12.7278 16.9945L12.5336 16.3967L13.0421 16.0273Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.3363 21.2771L11.1421 20.6793L11.6507 20.3099H11.022L10.8277 19.712L10.6335 20.3098H10.0049L10.5134 20.6793L10.3192 21.2772L10.8278 20.9077L11.3363 21.2771Z",
				fill: "#FFDA44"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_449",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgCapeVerde;
